// <head> metadata for JobsKeepMeInMindPage (https://www.dbos.dev/jobs/keep-me-in-mind).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: "Don't see an open position you'd like to fill? | DBOS",
    },
    {
      name: 'description',
      content: "Become a Don't see an open position you'd like to fill? at DBOS. Join our DBOS team. Apply today.",
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/jobs/keep-me-in-mind',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
